// AssignToKamModel.jsx

import { Modal } from "bootstrap";

import {
    forwardRef,
    useImperativeHandle,
    useRef,
    useState,
} from "react";

import Select from "react-select";

import {
    useForm,
    Controller,
} from "react-hook-form";

import { toast } from "react-toastify";

import { useNavigate } from "react-router-dom";

import * as b2cleadService from "../../Services/b2cleadService";

export const AssignToKamModel = forwardRef(
    (props, ref) => {

        const {
            getLeadData,
        } = props;

        const navigate = useNavigate();



        const {
            control,
            handleSubmit,
            reset,
            setValue,
            formState: { errors },
        } = useForm({
            mode: "onSubmit",
        });



        const modalRef = useRef(null);

        const bsModal = useRef(null);



        const [kamTypeOptions, setKamTypeOptions] =
            useState([]);

        const [employeeOptions, setEmployeeOptions] =
            useState([]);

        const [selectedLeadId, setSelectedLeadId] =
            useState(null);

        const [loader, setLoader] =
            useState(false);



        const handleClose = () => {

            reset();

            setEmployeeOptions([]);

            setSelectedLeadId(null);

            bsModal.current?.hide();

        };



        useImperativeHandle(ref, () => ({

            toggle(id) {

                setSelectedLeadId(id);

                if (!bsModal.current) {

                    bsModal.current =
                        new Modal(
                            modalRef.current
                        );

                }

                bsModal.current.show();

                getKamTypes();

            },

            close() {

                handleClose();

            },

        }));


        const getKamTypes = () => {

            b2cleadService

                .getAllMasterData(20)

                .then((res) => {

                    if (
                        res?.data?.data
                    ) {

                        const options =
                            res?.data?.data?.map(
                                (item) => ({

                                    label:
                                        item.name,

                                    value:
                                        item.name,

                                })
                            );

                        setKamTypeOptions(
                            options
                        );

                    }

                })

                .catch((err) => {

                    console.log(
                        "KAM TYPE ERROR",
                        err
                    );

                });

        };


        const getKamEmployee = (
            kamType
        ) => {

            b2cleadService

                .getKamEmployee(
                    kamType
                )

                .then((res) => {

                    if (
                        res?.data?.data
                    ) {

                        const options =
                            res?.data?.data?.map(
                                (item) => ({

                                    label:
                                        item.name,

                                    value:
                                        item.id,

                                })
                            );

                        setEmployeeOptions(
                            options
                        );

                    }

                })

                .catch((err) => {

                    console.log(
                        "EMPLOYEE ERROR",
                        err
                    );

                });

        };



        const onSubmit = async (
            data
        ) => {

            try {

                setLoader(true);

                const response =
                    await b2cleadService.addCustomer(
                        data?.employee?.value,
                        selectedLeadId
                    );

                if (
                    response?.data?.status ===
                    "success"
                ) {

                    toast.success(
                        response?.data?.message
                    );

                    handleClose();

                    getLeadData();
                    // navigate("/customers");

                } else {

                    toast.error(
                        response?.data?.message
                    );

                }

            } catch (error) {

                console.log(error);

                toast.error(
                    "Something went wrong"
                );
                // const message =
                //     error?.response?.data?.message;

                // toast.error(message);

            } finally {

                setLoader(false);

            }

        };

        return (

            <div
                className="modal fade"
                ref={modalRef}
                tabIndex="-1"
                aria-hidden="true"
                style={{
                    background:
                        "rgba(15,23,42,0.55)",

                    backdropFilter:
                        "blur(5px)",
                }}
            >

                <div className="modal-dialog modal-lg modal-dialog-centered">

                    <div className="modal-content border-0 rounded-4 ">

                        {/* HEADER */}
                        <div
                            className="modal-header border-0 text-white"
                            style={{
                                background:
                                    "linear-gradient(135deg,#2563eb,#1d4ed8)",
                            }}
                        >

                            <div>

                                <p className="mb-0 small opacity-75">

                                    Assign lead to KAM employee

                                </p>

                            </div>

                            <button
                                type="button"
                                className="btn btn-light rounded-circle position-absolute"
                                style={{
                                    top: "10px",
                                    right: "18px",
                                    width: "38px",
                                    height: "38px",
                                }}
                                onClick={
                                    handleClose
                                }
                            >

                                <i className="fa fa-times"></i>

                            </button>

                        </div>

                        {/* FORM */}
                        <form
                            onSubmit={handleSubmit(
                                onSubmit
                            )}
                        >

                            {/* BODY */}
                            <div className="modal-body p-4">

                                <div className="row g-4">

                                    {/* KAM TYPE */}
                                    <div className="col-md-6">

                                        <label className="form-label fw-semibold">

                                            Select KamType

                                            <span className="text-danger ms-1">
                                                *
                                            </span>

                                        </label>

                                        <Controller
                                            name="kamType"
                                            control={
                                                control
                                            }
                                            rules={{
                                                required:
                                                    "Please select KamType",
                                            }}
                                            render={({
                                                field,
                                            }) => (

                                                <>

                                                    <Select
                                                        {...field}
                                                        placeholder="Please Select"
                                                        options={
                                                            kamTypeOptions
                                                        }
                                                        className="react-select-container"
                                                        classNamePrefix="react-select"
                                                        value={
                                                            field.value || null
                                                        }
                                                        isClearable
                                                        isSearchable
                                                        onChange={(
                                                            selected
                                                        ) => {

                                                            // SET VALUE
                                                            field.onChange(
                                                                selected
                                                            );

                                                            // RESET EMPLOYEE
                                                            setValue(
                                                                "employee",
                                                                null
                                                            );

                                                            // REMOVE EMPLOYEE
                                                            setEmployeeOptions(
                                                                []
                                                            );

                                                            // GET EMPLOYEE
                                                            if (
                                                                selected?.value
                                                            ) {

                                                                getKamEmployee(
                                                                    selected?.value
                                                                );

                                                            }

                                                        }}
                                                    />

                                                    {errors.kamType && (

                                                        <small className="text-danger fw-semibold">

                                                            {
                                                                errors
                                                                    .kamType
                                                                    .message
                                                            }

                                                        </small>

                                                    )}

                                                </>

                                            )}
                                        />

                                    </div>

                                    {/* EMPLOYEE */}
                                    <div className="col-md-6">

                                        <label className="form-label fw-semibold">

                                            Select Employee

                                            <span className="text-danger ms-1">
                                                *
                                            </span>

                                        </label>

                                        <Controller
                                            name="employee"
                                            control={
                                                control
                                            }
                                            rules={{
                                                required:
                                                    "Please select employee",
                                            }}
                                            render={({
                                                field,
                                            }) => (

                                                <>

                                                    <Select
                                                        {...field}
                                                        placeholder="Please Select"
                                                        options={
                                                            employeeOptions
                                                        }
                                                        className="react-select-container"
                                                        classNamePrefix="react-select"
                                                        value={
                                                            field.value || null
                                                        }
                                                        isClearable
                                                        isSearchable
                                                        isDisabled={
                                                            employeeOptions.length === 0
                                                        }
                                                    />

                                                    {errors.employee && (

                                                        <small className="text-danger fw-semibold">

                                                            {
                                                                errors
                                                                    .employee
                                                                    .message
                                                            }

                                                        </small>

                                                    )}

                                                </>

                                            )}
                                        />

                                    </div>

                                </div>

                            </div>

                            {/* FOOTER */}
                            <div className="modal-footer border-0 px-4 pb-4">

                                <button
                                    type="button"
                                    className="btn btn-sm btn-light border rounded-pill px-4 fw-semibold"
                                    onClick={
                                        handleClose
                                    }
                                >

                                    Close

                                </button>

                                <button
                                    type="submit"
                                    className="btn btn-sm btn-primary rounded-pill px-4 fw-semibold shadow-sm"
                                    disabled={
                                        loader
                                    }
                                >

                                    {loader
                                        ? "Assigning..."
                                        : "Save"}

                                </button>

                            </div>

                        </form>

                    </div>

                </div>

            </div>

        );

    }
);

